import { render, staticRenderFns } from "./imageAssetModal.vue?vue&type=template&id=345b3e84&scoped=true"
import script from "./imageAssetModal.vue?vue&type=script&lang=js"
export * from "./imageAssetModal.vue?vue&type=script&lang=js"
import style0 from "./imageAssetModal.vue?vue&type=style&index=0&id=345b3e84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345b3e84",
  null
  
)

export default component.exports